import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=68a6a747&scoped=true&"
import script from "./TopBanner.vue?vue&type=script&lang=ts&"
export * from "./TopBanner.vue?vue&type=script&lang=ts&"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=68a6a747&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a6a747",
  null
  
)

export default component.exports